import { render, staticRenderFns } from "./UserManagementList.vue?vue&type=template&id=64972bf0&"
import script from "./UserManagementList.vue?vue&type=script&lang=js&"
export * from "./UserManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports